import React, { FC, useEffect } from 'react';
import { UtilizationItemsList } from './UtilizationItemsList';
import { NavigationProps } from '@interfaces/navigation';
import EventCharts from '@components/machines/components/eventsChart';
import Utilization from '@components/machines/components/Utilization';
import MachinesProvider from '@v2/pages/machines/common/providers/MachinesProvider/MachinesProvider';
import PerformanceScreenNet from '@v2/pages/performance/common/components/PerformanceScreenNet';
import { isPhone, isWeb } from '@helpers';
import { MODE } from '@v2/pages/machines/common/enums';
import { useChangeDisplayModeOnResize } from '@v2/pages/common/hooks/useChangeDisplayModeOnResize';
import { useAppDispatch } from '@store/hooks/useAppDispatch';
import { setCurrentScreenTitle } from '@reducers/header';
import i18n from 'i18n-js';

interface PerformanceUtilizationProps extends NavigationProps {}

const PerformanceUtilization: FC<PerformanceUtilizationProps> = ({ lg }) => {
  const { mode } = useChangeDisplayModeOnResize();
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setCurrentScreenTitle(i18n.t('Utilization')));
  }, []);

  return (
    <MachinesProvider
      mode={isWeb ? mode : isPhone ? MODE.DETAILS : MODE.FULL}
      lg={lg}
      panelViewMode={false} //TODO: remove this later
      onBack={() => {}}
      getList={(props) => <UtilizationItemsList {...props} data={props.machineListOEE.data} machinesLoaded={props.machineListOEE.loaded} />}
    >
      <PerformanceScreenNet screenName="MachinesPerformanceUtilization">
        <EventCharts getContentElement={(props) => <Utilization key="Utilization" {...props} />} />
      </PerformanceScreenNet>
    </MachinesProvider>
  );
};

export { PerformanceUtilization };
